// initial state
const state = () => ({
  isLightBoxOpen: false,
  youtubeId: null,
  videoDescription: []
});
// XXhmblzSAeU
// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  UPDATE_YOUTUBE_ID(state, id) {
    state.youtubeId = id;
  },
  UPDATE_COPY(state, val) {
    state.videoDescription = val;
  },
  TOGGLE_LIGHT_BOX(state, bool) {
    state.isLightBoxOpen = bool;
  },
  RESET_LIGHT_BOX(state) {
    state.youtubeId = null;
    state.videoDescription = [];
    state.isLightBoxOpen = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
